import { PurchaseWizard } from 'src/modals/PurchaseWizard';
import { PurchaseDeeplinkQueryParam } from 'src/utils/constants/constants';

export const PurchaseWizardModalConfig = (deepLinkValue?: number | string) => ({
  children: <PurchaseWizard deepLinkValue={deepLinkValue} />,
  clickOutsideToClose: true,
  deepLinkKey: PurchaseDeeplinkQueryParam,
  deepLinkValue: deepLinkValue,
  size: 'slide-in',
});
